module.exports = __webpack_public_path__ + "img/gdsc.fbe6321e.png";